import React, { useEffect, useState } from 'react';
import styles from './index.module.scss';
import { useDispatch, useSelector } from 'react-redux';
import { AddCustomPriceProduct } from '../../store/Slices/gifts/basketSlice';
import { currencySymbolPath, DEFAULT_CURRENCY, getSymbol } from '../../utils/currency';
import GiftsForm from '../Form';
import { Form } from 'react-final-form';
import { TextField } from '../../components/01_atoms/FormElements';
import { composeParsers, parseLengthLimit, parseOnlyDigits } from '../../utils/formFieldParsers';
import { composeValidators, minValue, required } from '../../utils/formFieldValidators';
import Button from '../../components/01_atoms/Button';
import { useRouter } from 'next/router';
import PropType from 'prop-types';
import { isCustomPrice } from '../../utils/Gifts/products';

const AddDonationForm = ({ product }) => {
  const dispatch = useDispatch();
  const basketProducts = useSelector((state) => state.basket.products);
  const [submitted, setSubmitted] = useState(false);
  const router = useRouter();

  // Redirect a user to basket page at once if "custom price corporate gift" has been added.
  // This trick is used to handle "Clean basket" popup case.
  useEffect(() => {
    if (basketProducts.length && submitted) {
      setSubmitted(false);
      setTimeout(() => router.push('/basket'), 1000);
    }
  }, [basketProducts]);

  const customProduct = basketProducts.filter((product) => isCustomPrice(product.data));

  const onSubmit = async (data) => {
    setSubmitted(true);
    dispatch(AddCustomPriceProduct({ product, amount: data.amount }));
  };

  const initialValues = {
    amount: customProduct.length ? customProduct[0].data.price[DEFAULT_CURRENCY].amount : '',
  };

  return (
    <GiftsForm>
      <Form
        onSubmit={onSubmit}
        initialValues={initialValues}
        render={({ handleSubmit }) => (
          <form className={styles['add-donation-form']} onSubmit={handleSubmit}>
            <TextField
              name="amount"
              parse={composeParsers(parseOnlyDigits, parseLengthLimit(8))}
              validate={composeValidators(
                required('Please add an amount'),
                minValue(1, `Please enter an amount greater than 0`),
              )}
              icon={currencySymbolPath[DEFAULT_CURRENCY]}
              autoComplete="off"
              inputMode="numeric"
              pattern="[0-9]+"
              placeholder=" "
              aria-label={getSymbol(DEFAULT_CURRENCY)}
              infoOnPatternNotMatched="Please use numbers only"
            />
            <div className={styles['add-donation-form__submit']}>
              <Button type="primary">Add to basket</Button>
            </div>
          </form>
        )}
      />
    </GiftsForm>
  );
};

AddDonationForm.propTypes = {
  product: PropType.object.isRequired,
};

export default AddDonationForm;
